// Generated by scripts/generate-version.js during build. Do not edit.
export const versionInfo = {
  version: '4.2.2',
  commit: 'a9c339ed',
  isRelease: false,
};
